import SceneLayout from './SceneLayout';
import SuspenseLayout from './SuspenseLayout';

const Layout = {
  Scene: SceneLayout,
  Suspense: SuspenseLayout,
};

export default Layout;
